import { useState } from 'react'

// ///////////////////////
// MARK: EXPORTS
export const useDisplayMode = () => {
  const [state] = useState<'browser' | 'fullscreen'>(() => {
    if (window.matchMedia('(display-mode: fullscreen)').matches) {
      return 'fullscreen'
    }

    return 'browser'
  })

  return state
}
